import { Injectable } from "@angular/core";
import { RemoteRepositoryInterface } from "../../remote/remote.interface";
import { ProductRepositoryInterface } from "./product.interface";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { ProductModel } from "../../entities/product.model";
import { ProductInfoModel } from "../../entities/productinfo.model";

@Injectable()
export class ProductRepository implements ProductRepositoryInterface {

    constructor(private remoteRepository: RemoteRepositoryInterface) {}

    public syncProducts(): Observable<ProductModel[]> {
        const url = "syncProducts";
        return this.remoteRepository.get(url).pipe(
            map((response: []) => {
                const products: ProductModel[] = [];
                for(const prod of response) {
                    products.push(new ProductModel(prod as JSON));
                }
                return this.sortProducts(products);
            }));
    }

    public getProducts(search?: string): Observable<ProductModel[]> {
        let url = "products";
        if(search) {
            url += "?search=" + search;
        }
        return this.remoteRepository.get(url).pipe(
            map((response: []) => {
                const products: ProductModel[] = [];
                for(const prod of response) {
                    products.push(new ProductModel(prod as JSON));
                }
                return this.sortProducts(products);
            }));
    }

    public getProductInfo(speCod: string, varCod: string, lang: string): Observable<ProductInfoModel> {
        let url = "productInfo";
        url += "?spe=" + speCod;
        url += "&var=" + varCod;
        url += "&lang=" + lang;
        return this.remoteRepository.get(url).pipe(
            map((response) => new ProductInfoModel(response as JSON)));
    }

    private sortProducts(products: ProductModel[]) {
        products.sort(function(a, b) {
            if(a.varDex < b.varDex) {
                return -1;
            }
            if(a.varDex > b.varDex) {
                return 1;
            }
            return 0;
        });
        return products;
    }
}
